<template>
  <!-- eslint-disable max-len -->
  <el-dialog
    title="更新授权码"
    :visible="visible"
    @close="onClose"
    @open="onOpen"
    width="40%"
    top="10vh"
    :close-on-click-modal="false"
    :modal-append-to-body="false"
  >
    <el-form :model="item" ref="itemform" label-width="120px" :rules="rules">
      <el-form-item label="业务类型" prop="BusinessTypeID">
        <select2
          style="width: 100%"
          v-model="item.BusinessTypeID"
          url="basic?type=BusinessType"
          :clearable="false"
          placeholder="请选择业务类型"
          noDataText="无类型"
        ></select2>
      </el-form-item>
      <el-form-item label="产品名称" prop="SoftwareID">
        <select2
          style="width: 100%"
          v-model="item.SoftwareID"
          :url="softwareUrl"
          placeholder="请选择产品"
          :disabled="!item.BusinessTypeID"
          no-data-text="无产品"
          :emptyValue="0"
        ></select2>
      </el-form-item>
      <el-form-item label="产品版本" prop="TargetVersion">
        <select2
          style="width: 100%"
          v-model="item.TargetVersion"
          :url="versionUrl"
          placeholder="请选择版本"
          no-data-text="无版本"
          :disabled="!item.SoftwareID"
          labelName="Version"
          valueKey="Version"
        ></select2>
      </el-form-item>
      <el-form-item label="功能版本" prop="FunctionID">
        <select2
          style="width: 100%"
          v-model="item.FunctionID"
          :url="functionUrl"
          :clearable="false"
          :disabled="!item.TargetVersion"
          placeholder="请选择版本"
          noDataText="无版本"
          labelName="Name"
          valueKey="ID"
        ></select2>
      </el-form-item>
    </el-form>
    <el-table
      :data="itemList"
      v-loading="loading"
      @select="handleSelectionChange"
      @select-all="handleSelectionChange"
      ref="multipleTable"
    >
      <el-table-column
        type="index"
        :index="pager.size * (pager.page - 1) + 1"
        :width="Math.max(48, (pager.size * pager.page).toString().length * 12)"
      ></el-table-column>
      <el-table-column prop="Station.Name" label="站点名称"></el-table-column>
      <el-table-column type="selection" checked="true"></el-table-column>
    </el-table>
    <div class="clearfix mar-top-10">
      <el-pagination
        class="pull-right"
        @current-change="onChangePage"
        layout="total, prev, pager, next"
        :total="pager.total"
        :current-page="pager.page"
        :page-size="pager.size"
      ></el-pagination>
    </div>
    <div slot="footer">
      <el-button @click="onClose">
        <i class="fas fa-times"></i> 取 消
      </el-button>
      <el-button
        type="primary"
        @click="onSubmit"
        :disabled="submitting || !multipleSelection.length"
      >
        <i class="far fa-save"></i> 确 定
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    value: Object,
    visible: Boolean,
  },
  data() {
    return {
      rowData: {},
      itemList: [],
      loading: false,
      submitting: false,
      multipleSelection: [],
      item: {},
      rules: {
        BusinessTypeID: [
          { required: true, message: "请选择业务类型", trigger: ["blur"] },
        ],
        SoftwareID: [
          { required: true, message: "请选择产品", trigger: ["blur"] },
        ],
        TargetVersion: [
          { required: true, message: "请选择产品版本", trigger: ["blur"] },
        ],
        FunctionID: [
          { required: true, message: "请选择功能版本", trigger: ["blur"] },
        ],
      },
      versionUrl: "",
      softwareUrl: "",
      functionUrl: "",
      Version: {},
      versionID: null,
      pager: {
        total: 0,
        page: 1,
        size: 15,
      },
    };
  },
  computed: {
    token() {
      return this.$store.state.auth.token;
    },
  },
  watch: {
    "item.BusinessTypeID": {
      handler() {
        this.$set(this.item, "SoftwareID", null);
        this.softwareUrl = `software?Main=2&&order=spe_nb&&where[BusinessTypeID]=${this.item.BusinessTypeID}`;
      },
    },
    "item.SoftwareID": {
      handler() {
        this.$set(this.item, "TargetVersion", null);
        this.versionUrl = `software/version?where[SoftwareID]=${this.item.SoftwareID}&where[Status]=1`;
        this.$axios
          .get(this.versionUrl, {
            params: {
              where: { SoftwareID: this.item.SoftwareID },
            },
          })
          .then((response) => {
            this.Version = response.data.data;
          });
      },
    },
    "item.TargetVersion": {
      handler() {
        this.$set(this.item, "FunctionID", null);
        if (this.Version.length > 0) {
          for (const version of this.Version) {
            if (version.Version === this.item.TargetVersion) {
              this.versionID = version.ID;
              break;
            }
          }
          this.functionUrl = `functionversion?where[VersionID]=${this.versionID}`;
        }
      },
    },
  },
  methods: {
    onOpen() {
      this.rowData = _.clone(this.value);
      this.getItemList();
    },
    onClose() {
      this.$emit("update:visible", false);
      this.$emit("cancel");
      this.$refs.itemform.resetFields();
      this.multipleSelection = [];
      this.item = {};
    },
    getItemList() {
      this.loading = true;
      this.$axios
        .get(`/contract/${this.$route.params.ID}/update/stationshow`, {
          params: {
            where: { BusinessTypeID: this.item.BusinessTypeID },
            ...this.pager,
          },
        })
        .then((response) => {
          this.itemList = response.data.data;
          this.pager = _.pick(response.data, "size", "page", "total");
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onChangePage(page) {
      this.pager.page = page;
      this.getItemList();
    },
    handleSelectionChange(list) {
      this.multipleSelection = [];
      list.forEach((element) => {
        this.multipleSelection.push(element.StationID);
      });
    },
    onSubmit() {
      this.$refs.itemform.validate((valid) => {
        if (!valid) {
          return;
        }
        this.submitting = true;
        this.$emit("input", this.item);
        const itemData = { ...this.item };
        itemData.ContractID = parseInt(this.$route.params.ID, 10);
        itemData.SIDS = this.multipleSelection;
        // 保存的操作
        this.$axios
          .request({
            url: `/contract/${this.$route.params.ID}/batchupdate`,
            method: "post",
            data: itemData,
          })
          .then(() => {
            this.$message.success("更新成功");
            this.submitting = false;
            this.$emit(itemData.ID ? "form:updated" : "form:created", true);
            this.$emit("form:saved", true);
            this.$emit("update:visible", false);
          })
          .catch(({ response }) => {
            this.$sys.alarmResponse(response);
            this.submitting = false;
            this.$emit(itemData.ID ? "form:updated" : "form:created", false);
            this.$emit("form:saved", false);
          });
      });
    },
  },
};
</script>
